import React, { useEffect, useState } from "react";
import { SdsForm, SmartSoftButton } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useSiteContext } from "../../contexts/SiteProvider";
import { post } from "../../services/smartApiService";
import { showAlertAutoClose } from "../../services/notifyService";
import { PRACTICAL_URLS } from "../../api/AdminUrls";
import { admin_category_select } from "../../services/site/SelectBoxServices";

const validationSchema = Yup.object({
  category_id: Yup.object().required("Category is required"),
  question_text: Yup.string().required("Question is required"),
});

interface HeaderProps {
  loadTableData: () => void;
  data: any;
}
const PracticalQuestionsForm: React.FC<HeaderProps> = ({
  loadTableData,
  data,
}) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      ...data,
    },
  });

  const { closeModal } = useSiteContext();
  const [category, setCategory] = useState([]);

  useEffect(() => {
    admin_category_select((data: any) => setCategory(data));
  }, []);

  const onSubmit = (data: any) => {
    let url = PRACTICAL_URLS.INSERT;
    if (data.ID !== undefined) {
      data["id"] = data.ID;
      url = PRACTICAL_URLS.UPDATE;
    }

    const subscription = post(url, data).subscribe(() => {
      showAlertAutoClose("Data Saved Successfully", "success");
      closeModal();
      loadTableData();
    });

    return () => subscription.unsubscribe();
  };

  const elements: SdsFormElementProps[] = [
    {
      type: "SELECT_BOX",
      width: 6,
      name: "category_id",
      element: {
        label: "Category",
        isRequired: true,
        options: category,
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "question_text",
      element: { label: "Questions", isRequired: true },
    },

    {
      type: "BUTTON",
      width: 12,
      name: "smart",
      class_name: "has-text-right",
      element: {
        classList: ["smart-action-button"],
        label: data.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];

  return (
    <div className="sd-hims-input">
      <SdsForm elements={elements} errors={errors} control={control} />
    </div>
  );
};

export default PracticalQuestionsForm;
